import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './actions';

@Injectable({
	providedIn: 'root',
})
export class FireInsuranceBrokersDispatch {
	@Dispatch()
	Search = (searchTerm: string, brokerageId?: string): actions.Search =>
		new actions.Search({ searchTerm, brokerageId });
}
